import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const postcodeRegex = /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}|GIR ?0A{2})$/i;

export function postcodeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value || '').toString().trim();

    if (!value || postcodeRegex.test(value)) {
      return null;
    }

    return { postcode: true };
  };
}
